import React, { useContext, useEffect, useMemo, useState } from "react";
import { Context } from "../../../../utils/context";
import "../FifithJobTab/FifthJobTab.css";
import Card from "react-bootstrap/Card";
import ListGroup from "react-bootstrap/ListGroup";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "@fortawesome/fontawesome-svg-core/styles.css";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import ApplyModal from "../../ApplyModel/ApplyModal";
import {
  faEllipsisVertical,
  faClock,
  faGraduationCap,
  faBriefcase,
  faDesktop,
  faMoneyBill,
  faStar,
} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import JobDescriptionModal from "../../JobDescriptionModel/JobDescriptionModal";
import Common_Ad_Banner from "../../../common_components/common_ad_banner/Common_Ad_Banner";
import { BannersIDS, commonBannerApi } from "../../../../utils/commonBannerApi";
import JobCard from "../../../common_components/JobCard/JobCard";

const FifthJobTab = (props) => {
  const [modalShow1, setModalShow1] = useState(false);

  const [data, setData] = useState({});
  console.log(data, "data");

  const {
    jobSeekerData,
    fetchSeekerData,
    getData,
    imageUrl,
    NoDataAnimations,
  } = useContext(Context);
  const [modalShow, setModalShow] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    contact: "",
    job_id: "",
  });

  useEffect(() => {
    if (data?.id) {
      setFormData((prev) => ({
        ...prev,
        job_id: data.id,
      }));
    }
  }, [data]);

  const [savedData, setSavedData] = useState();
  const getSavedJobs = async () => {
    const res = await getData(`/jobseeker/saved`);
    if (res?.success) {
      setSavedData(res.data);
    }
  };

  const handleApply = async (data) => {
    await setFormData({
      name: jobSeekerData?.first_name + jobSeekerData?.last_name,
      email: jobSeekerData?.email,
      contact: jobSeekerData?.contact_no,
      job_id: data?.id,
    });
    setModalShow1(true);
  };

  useEffect(() => {
    getSavedJobs();
    fetchSeekerData();
  }, []);

  // const imgSrc = [
  //   "/assets/Images/blog/img1.png",
  //   "/assets/Images/blog/img1.png",
  // ];

  const [imgSrc, setImgSrc] = useState([]);

  const getBanners = async () => {
    try {
      const res = await commonBannerApi(BannersIDS.JSPSavedJobs);
      if (res?.success) {
        setImgSrc(res.data || []);
      }
    } catch (error) {
      console.error("Error fetching banners:", error);
    }
  };

  useEffect(() => {
    getBanners();
  }, []);

  const imgSrcNew = useMemo(() => imgSrc.map((item) => item?.image), [imgSrc]);

  return (
    <>
      <section className="SaveJob">
        <div className="container">
          <div className="sec-title mt-md-2 mt-2">
            <h5 className="title-talent">Saved Jobs</h5>
          </div>

          <div className="row justify-content-center">
            <div className="col-lg-9">
              <div className="cards">
                <div className="row mt-4">
                  {savedData?.map((value, index) => (
                    <div
                      className="col-12 col-12 mb-4"
                      key={index}
                    >
                      <JobCard
                        job={value.job}
                        imageUrl={imageUrl}
                        onViewJD={(job) => {
                          setData(job);
                          setModalShow(true);
                        }}
                        onApply={(job) => {
                          setData(job);
                          handleApply(job); // or setModalShow1(true)
                        }}
                      />
                    </div>
                  ))}
                  {savedData?.length == 0 && <NoDataAnimations />}
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-sm-4 col-10 mb-5">
              <Common_Ad_Banner imgSrc={imgSrcNew} />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default FifthJobTab;
